import BonusBuyPrompt from 'components/bonus-buy/bonus-buy-prompt';
import { BounceZoomIn, BounceZoomOut, FadeIn, FadeOut } from 'slotworks/graphics/animation/base-animations';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import currency from 'slotworks/i18n/currency';
import betModel from 'slotworks/model/bets/bet-model';
import Contract from 'slotworks/utils/contract';
import * as TweenJS from 'slotworks/utils/tween';
import deviceInfo from 'slotworks/utils/device-info';
import canvasManager from 'slotworks/graphics/canvas/canvas-manager';

export default class BonusBuyTransition extends AbstractSceneTransition {
    private glow2: PIXI.Sprite;
    private glow3: PIXI.Sprite;

    public in(): Contract<void> {
        const currentBet = betModel.getTotalBet();
        const osBet = Layers.Prompts.getText('outlaw_bet');
        const osValue = Layers.Prompts.getBitmapText('outlaw_value');
        const match3Bet = Layers.Prompts.getText('match_bet');
        const match3Value = Layers.Prompts.getBitmapText('match_value');

        osBet.text = currency.format(currentBet);
        osValue.text = currency.format(currentBet * BonusBuyPrompt.MULTIPLIER_OS, undefined, undefined, true);
        match3Bet.text = currency.format(currentBet);
        match3Value.text = currency.format(currentBet * BonusBuyPrompt.MULTIPLIER_M3, undefined, undefined, true);
        this.startStacks();
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.add(this.onOrientationChange);
            Layers.CelebrationBackground.getSprite('filter').position.set(0, 0);
            Layers.CelebrationBackground.getSprite('filter').scale.set(3, 3);            
        }
        FadeIn(Layers.CelebrationBackground.getSprite('filter'), 200).execute();
        return BounceZoomIn(Layers.Prompts.container, 400);
    }

    public out(): Contract<void> {
        if(!deviceInfo.isDesktop) deviceInfo.onLayoutChange.remove(this.onOrientationChange);
        this.stopStacks();
        FadeOut(Layers.CelebrationBackground.getSprite('filter'), 300).execute();
        FadeOut(this.glow2, 400).execute();
        FadeOut(this.glow3, 400).execute();
        return BounceZoomOut(Layers.Prompts.container, 400);
    }

    private onOrientationChange = () => {
        setTimeout(() => {
            const position = Layers.CelebrationBackground.getPosition("glow");
            if(position) {
                const x = position.x + position.width/2;
                const y = position.y + position.height/2;
                this.glow2.position.set(x, y);
                this.glow3.position.set(x, y);
            }
        }, 1);
    }

    private startStacks() {
        this.glow2 = Layers.CelebrationBackground.getSprite('glow_2');
        this.glow2.anchor.set(0.5, 0.5);
        this.glow3 = Layers.CelebrationBackground.getSprite('glow_3');
        this.glow3.anchor.set(0.5, 0.5);
        this.glow2.x += this.glow2.width / 2;
        this.glow2.y += this.glow2.height / 2;
        this.glow3.x += this.glow3.width / 2;
        this.glow3.y += this.glow3.height / 2;
        const rotation = Math.PI / 64;
        this.glow3.rotation = -rotation;
        new TweenJS.Tween(this.glow3)
            .to({ rotation }, 2500)
            .repeat(Infinity)
            .yoyo(true)
            .start();
        new TweenJS.Tween(this.glow2)
            .to({ alpha: 0.8 }, 200)
            .repeat(Infinity)
            .delay(100)
            .yoyo(true)
            .start();
        FadeIn(this.glow2, 400).execute();
        FadeIn(this.glow3, 400).execute();
    }

    private stopStacks() {
        TweenJS.removeAll(this.glow2);
        TweenJS.removeAll(this.glow3);
    }

    public destroy() {
        this.stopStacks();
    }
}



// WEBPACK FOOTER //
// ./src/transitions/bonus-buy-transition.ts